import { useMemo } from "react";
import { useFetch } from "../useFetch";
import { PagedResultDto } from "../../types/api/PagedResultDto";
import { GroupGeofence } from "../../types/api/guide/groupGeofence.types";
import { groupGeofenceService } from "../../services/guide/groupGeofence-service";

export const useFetchPagedGroupGeofence = (page: number, pageSize: number, name?: string) => {
    const params = useMemo(() => [page, pageSize, name] as const, [page, pageSize, name]);
    return useFetch<PagedResultDto<GroupGeofence>>(
        groupGeofenceService.getPaged,
        params as unknown as [number, number, string?]
    );
};
